<div [ngClass]="{'desktop-modal': !isMobile, 'mobile-modal': isMobile, 'clear-button no-outline alert-box': true}">
  @if (!message.isProgress) {
    <mat-icon
      (click)="onClose()"
      alt="Close"
      loading="lazy"
      role="button"
      [ngClass]="{'close-button': !isMobile, 'close-button-mobile': isMobile}"
      [svgIcon]="'close'">
    </mat-icon>
  }
  @if (!message.isSuccess && !message.isProgress) {
    <mat-icon
      alt="Error"
      loading="lazy"
      class="check-img"
      [svgIcon]="'error'">
    </mat-icon>
  }
  @if (message.isSuccess && !message.isProgress) {
    <mat-icon
      alt="Success"
      loading="lazy"
      class="check-img"
      [svgIcon]="'checked'">
    </mat-icon>
  }
  @if (message.isProgress) {
    <mat-icon
      alt="Sending"
      loading="lazy"
      class="check-img"
      [svgIcon]="'send'">
    </mat-icon>
  }

  <!-- Display a progress bar if it is a progress message and not a success message -->
  @if (message.isProgress && !message.isSuccess) {
    <mat-progress-bar [value]="progressValue" color='primary' mode="determinate"></mat-progress-bar>
  }

  <!-- Display the translated title and description -->
  <div>
    <p class="bold-center text-center">{{ message.title | translate }}</p>
    <p class="text-center">{{ message.description | translate }}</p>
  </div>

  @if (message.errorCode) {
    <div>
      <p class="bold-center text-center">{{ "errorCode" | translate }} {{ message.errorCode }}</p>
    </div>
  }

  <!-- Display error report button -->
  @if (message.showErrorReport) {
    <div>
      <button
        (click)="openTechnicalFeedbackEmail()"
        class="btn btn-primary">
        {{ 'shared.sendReport' | translate }}
      </button>
      <p class="text-center">{{ 'shared.alternativeReport' | translate }}</p>
      <p class="text-center">{{ 'menu.customerService' | translate }}: {{ customerService }}</p>
      <p class="text-center">{{ "generalFeedback.sessionId" | translate }} {{sessionId}}</p>
      <p class="text-center">{{ "generalFeedback.userPlatform" | translate }} {{userPlatform}}</p>
    </div>
  }
</div>
